import { UserWorkspaceRole } from "@common/userWorkspaceRoles";
import { useHasAtLeastRole } from "./useHasAtLeastRole";

export function useCanManageAccounts() {
    return useHasAtLeastRole(UserWorkspaceRole.ACCOUNTANT);
}
